import { EmptyContentIcon } from '../..';
import { EmptyLayout, type EmptyLayoutProps } from './empty-layout';

export interface EmptyContentProps extends EmptyLayoutProps {}

export const EmptyContent = memo(function EmptyContent({
  children,
  ...props
}: EmptyContentProps) {
  return (
    <EmptyLayout icon={<EmptyContentIcon />} {...props}>
      {children || 'No data'}
    </EmptyLayout>
  );
});
